import React from "react";
import PropTypes from "prop-types";

const CardShortText = ({ children = null, className = "", ...rest }) => {
  return <div className={`card__text`}>{children}</div>;
};

CardShortText.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default CardShortText;
